import mutations from '@fps/vue-toolkit/dist/store/temp/temp.mutationlist';

export default Object.assign({}, mutations, {
  CHANGE_CATEGORIES: 'CHANGE_CATEGORIES',
  VISIBLE_GRID: 'VISIBLE_GRID',
  PAN_EVENT: 'PAN_EVENT',
  SWIPE_LEFT_EVENT: 'SWIPE_LEFT_EVENT',
  SWIPE_RIGHT_EVENT: 'SWIPE_RIGHT_EVENT',
  TOGGLE_LEFT_MENU: 'TOGGLE_LEFT_MENU',
  TOGGLE_MENU: 'TOGGLE_MENU',
  TOGGLE_RIGHT_MENU: 'TOGGLE_RIGHT_MENU',
  FACEBOOK_INITIALIZED: 'FACEBOOK_INITIALIZED',
  GOOGLE_INITIALIZED: 'GOOGLE_INITIALIZED',
});



// WEBPACK FOOTER //
// ./src/store/temp/temp.mutationlist.js